<!-- <app-header></app-header> -->
<section class="dashboard-wrap">
    <div class="container-fluid">
        <div class="dash-board-main">
            <div class="sidebar-backdrop" *ngIf="!menuToggle" (click)="closeSidebar()"></div>
            <div class="left-side" [ngClass]="{'w-20': !menuToggle, 'close-menu' : menuToggle }">
                <div class="side-dashboard" *ngIf="display_admin_or_customer_menus == 'admin'">
                    <div class="dashboard-avatar">
                        <div class="dashboard-avatar-block">
                            <div class="folder-toggle">
                                <!-- <i (click)="closeAllMenu()" class="bi bi-folder-fill"></i> -->
                                <!-- <img src="assets/collapse2.png" alt=""> -->
                                <svg width="26px" height="26px" (click)="closeAllMenu()" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <title>Collapse Menu</title>
                                    <path d="M19 15H15M15 15V19M15 15L19 19M5 9H9M9 9V5M9 9L5 5" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" style=""></path><path d="M19 9H15M15 9V5M15 9L19 5M5 15H9M9 15V19M9 15L5 19" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" style=""></path></svg>
                                <!-- <i (click)="closeAllMenu()" class="fa fa-regular fa-folder-open"></i> -->
                            </div>
                            <div class="dashboard-avatar-thumb">
                                <img routerLink="profile" routerLinkActive="active" src="assets/img/dummy-image.jpeg" class="img-avater" alt="" />
                            </div>
                            <div class="dashboard-avatar-text">
                                <h4>{{userName}}</h4>
                                <p>{{userEmail}}</p>
                            </div>
                        </div>
                   
                    </div>
                    
                    <div class="dashboard-menu">
                        <ul>
                            <li><a (click)="dashboardSelect()" routerLink="dash-board" id="dashboard-route" class="" routerLinkActive="active"><i class="bi bi-geo-alt bi-geo-alt1"></i>Dashboard</a></li>

                            <!-- <li><a (click)="routeLink('dash-board')" routerLink="dash-board" routerLinkActive="active"><i class="bi bi-square-fill dashboard-icon"></i>Dashboard</a></li> -->
                            <li *ngFor="let menu of menus;let i = index">
                                <a (click)="toggleMenu(i)" class="{{menu.isSelect}}" id="menu-r{{i}}"><i id="folder-r{{i}}" class="{{menu.icon}}"></i>{{menu.title}}</a>
                                <ul class="subMenu {{menu.isOpen}}" id="subMenu{{i}}">
                                    <li (click)="routeLink(subMenu.link, menu.title)" class="{{subMenu.isSelect}}" id="sub{{i}}menu{{j}}" *ngFor="let subMenu of menu.children;let j = index"><i class="{{subMenu.icon}}"></i> {{subMenu.title}}</li>
                                </ul>
                            </li>
                        </ul>
                    </div>
                </div>


                <div class="side-dashboard"  *ngIf="display_admin_or_customer_menus == 'customer'">
                    <div class="dashboard-avatar">
                        <i (click)="goToCustomer()" class="bi bi-x-lg"></i>

                        <div class="dashboard-avatar-thumb">
                            <img routerLink="profile" routerLinkActive="active" src="assets/img/dummy-image.jpeg" class="img-avater" alt="" />
                        </div>
                        <div class="dashboard-avatar-text" *ngFor="let user of userData">
                            <h4>{{user.userName}}</h4>
                            <span>{{user.userEmail}}</span>
                        </div>
                    </div>

                    <div class="dashboard-menu">
                        <ul>
                            <li *ngFor="let menu of customerMenus"><a (click)="goToLink(menu.link)"><i class="bi bi-folder-fill"></i>{{menu.title}}</a></li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="right-side" [ngClass]="{'w-100': menuToggle,'pd': menuToggle, 'w-80' : !menuToggle }">
                <app-header></app-header>
                <router-outlet></router-outlet>
            </div>
        </div>
    </div>
</section>